export class StandardResponseMessage {
  errors: string[];
  success: boolean;

  constructor(success?: boolean, errors?: string[]) {
    this.errors = errors || [];
    this.success = (success) || false;
  }
}
